import React from 'react';
import { SignupProgressTrackerStep } from 'src/components/common/features/Signup/components/SignupProgressTracker/SignupProgressTrackerStep/SignupProgressTrackerStep';
import { useSignupStatus } from 'src/components/selfService/features/Signup/context/SignupStatusProvider/SignupStatusProvider';
import { ISignupStep } from 'src/components/common/features/Signup/components/SignupProgressTracker/SignupProgressTracker';
import {
  IEnterpriseSignupStep,
  useEnterpriseSignupStatus,
} from 'src/components/EnterpriseSignupStatusProvider/EnterpriseSignupStatusProvider';

export interface IProgressTrackerStepsProps {
  steps: ISignupStep[] | IEnterpriseSignupStep[];
  isInWelcomeModal?: boolean;
  isEnterprise?: boolean;
}

export function ProgressTrackerSteps({
  steps,
  isInWelcomeModal,
  isEnterprise,
}: IProgressTrackerStepsProps): JSX.Element {
  const { activeStep, isStepCompleted } = isEnterprise
    ? useEnterpriseSignupStatus()
    : useSignupStatus();

  const progressTrackerSteps = [];

  let isStepComplete = false;
  let isStepActive = false;
  let isNextStepComplete = false;
  let isNextStepActive = false;

  for (let i = 0; i < steps.length; i += 1) {
    const isFirstStep = i === 0;
    const isLastStep = i === steps.length - 1;
    const currentStep = steps[i];
    const nextStep = !isLastStep ? steps[i + 1] : null;

    if (isFirstStep) {
      isStepComplete = isStepCompleted(currentStep.id as never);
      isStepActive = currentStep.id === activeStep;
    } else {
      isStepComplete = isNextStepComplete;
      isStepActive = isNextStepActive;
    }

    let isNextStepCompleteOrActive = false;
    if (nextStep) {
      isNextStepComplete = isStepCompleted(nextStep.id as never);
      isNextStepActive = nextStep.id === activeStep;
      isNextStepCompleteOrActive = isNextStepComplete || isNextStepActive;
    }

    progressTrackerSteps.push(
      <SignupProgressTrackerStep
        key={currentStep.id}
        isStepComplete={isStepComplete}
        isStepActive={isStepActive}
        isNextStepCompleteOrActive={isNextStepCompleteOrActive}
        stepNumber={i + 1}
        stepContent={currentStep.content}
        stepName={currentStep.name}
        isInWelcomeModal={isInWelcomeModal}
        isLastStep={isLastStep}
      />
    );
  }

  return <>{progressTrackerSteps}</>;
}
